import React, { useContext, useEffect, useState } from 'react'
import StoreContext from '~/context/StoreContext'
import { Link } from 'gatsby'
import {
  ProductImg,
  ImgWrapper,
  ImgBanner,
  BottomBannerText,
  HoverBanner,
  Wrapper,
  HoverTitle,
  HoverPrice,
} from './styles'

const ProductGridItem = ({ product, delay, multiplier }) => {
  const [showContent, setShowContent] = useState(false)
  const {
    store: { checkout },
  } = useContext(StoreContext)

  useEffect(() => {
    setTimeout(() => {
      setShowContent(true)
    }, delay * multiplier)
  }, [])

  const getPrice = price =>
    Intl.NumberFormat(undefined, {
      currency: checkout.currencyCode ? checkout.currencyCode : 'USD',
      minimumFractionDigits: 2,
      style: 'currency',
    }).format(parseFloat(price || 0))

  return (
    <>
      {showContent && (
        <Wrapper>
          <Link to={`/product/${product.handle}/`}>
            <ImgWrapper>
              {product.images[0] && product.images[0].localFile && (
                <ProductImg fluid={product.images[0].localFile.childImageSharp.fluid} alt={product.handle} />
              )}
              <HoverBanner>
                <HoverTitle>{product.title.toUpperCase()}</HoverTitle>
                <HoverPrice>{getPrice(product.variants[0].price)}</HoverPrice>
              </HoverBanner>
              {!product.availableForSale && (
                <ImgBanner>
                  <BottomBannerText>SOLD OUT</BottomBannerText>
                </ImgBanner>
              )}
            </ImgWrapper>
          </Link>
        </Wrapper>
      )}
    </>
  )
}

export default ProductGridItem
